module.exports = __webpack_public_path__ + "img/image_btn.39d502c7.png";